module.exports = __webpack_public_path__ + "static/media/code-commit.16e0453b.svg";